




import { Component, Prop } from 'vue-property-decorator';
import Sortable from 'sortablejs';
import { List as ListBase, ListAction, HeaderConfig, createEntity, NewEntity } from '@/base';
import { CashAccountTransactionPositionJson } from '../json';
import CashAccountTransactionPositionList from '../base/CashAccountTransactionPositionList.vue';
import { CreditJson, store as creditStore } from '@/modules/financialdocument/credit';

@Component<PositionListCredit>({
  props: {
    items: {
      required: true,
    },
  },
  mounted()
  {
    this.sortable = new Sortable(this.$el.querySelector('tbody')!, {
      draggable: 'tr:not(.add-row)',
      handle: '.drag-handle:not(.v-icon--disabled)',
    });
  },
  destroyed()
  {
    if (this.sortable)
    {
      this.sortable.destroy();
    }
  },
})
export default class PositionListCredit extends CashAccountTransactionPositionList<CreditJson>
{

  public readonly items: NewEntity<CashAccountTransactionPositionJson<CreditJson>>[];

  private entityStore = creditStore;

  protected getFinancialDocumentLabel(): string
  {
    return this.getLabel('header.credit');
  }

  protected getFullName(item: CreditJson): string
  {
    return item ? item.id + ' - ' + item.creditReference : '';
  }

  /**
   * Adds a new item if the newDescription model has a value.
   */
  protected addItemIf(): void
  {
    if (this.newEntity)
    {
      this.items.push(createEntity({
        assignedPriceNet: -this.newEntity.documentValueNet,
        assignedPriceGross: -this.newEntity.documentValueGross,
        entity: this.newEntity,
      }));
      this.newEntity = null;
    }
  }
}
